import React from 'react'
import PropTypes from 'prop-types'

import { QuestionTitle, QuestionDescription } from '@prehook/shared'
import { parseRecallVariables } from '@/utils'

const Question = ({ formField, theme, shortId }) => {
  const { questionColor, font } = theme
  const { title, description, showDescription, required, fieldType } = formField
  const parsedTitle = parseRecallVariables(shortId, title)

  return (
    <>
      <QuestionTitle
        text={parsedTitle}
        color={questionColor}
        font={font}
        required={required}
        fieldType={fieldType}
      />
      {showDescription && (
        <QuestionDescription
          text={description}
          color={questionColor}
          font={font}
          fieldType={fieldType}
        />
      )}
    </>
  )
}

Question.propTypes = {
  formField: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default Question
